import { pageNames } from '@atc/bonnet-paths';
import { getPath } from '.';
import { fetchKbbRating } from '../fetchers';
import { get } from './common';

export default async (listings = [], owner = {}, brand = 'atc') => {
    // Repopulate rating value and rating count using Kbb Rating API
    if (owner && owner.rating) {
        const svocId = owner.id;
        const kbbRating = await fetchKbbRating(svocId);
        if (kbbRating.count === 0 || kbbRating.kbbDealerRating < 1) {
            delete owner.rating;
        } else {
            owner.rating.count = kbbRating.count;
            owner.rating.value = kbbRating.kbbDealerRating;
        }
    }

    // Assign corrected phoneNumber from listing to owner
    const phoneNumber = get(listings, '0.owner.phone.value');
    if (phoneNumber && owner?.phone) {
        owner.phone = { ...owner.phone, value: phoneNumber };
    }

    // Update inventory data
    let listingData = {
        urls: {},
        activeResults: [],
        inventory: [],
    };

    if (listings) {
        listingData = await listings.reduce(async (previous, listing) => {
            // we must resolve the previous async value
            const acc = await previous;

            // Generate a VDP url for each listing
            const { id: listingId } = listing;
            const path = await getPath(pageNames.VEHICLE_DETAILS, { listingId }, brand);
            acc.urls[listingId] = path;

            // Generate a VDP url for each home service link with anchor
            if (listing && listing.website) {
                listing.website.href = path;
            }

            // add the owner and push to the inventory collection
            acc.inventory.push({ ...listing, owner: listing.owner.id });

            // Push listing to active results
            acc.activeResults.push(listingId);

            // remove images data as we just use one first image for inventory card
            if (listing?.images?.sources?.length > 0) {
                listing.images.sources = [listing.images.sources[0]];
            }

            // remove owner data from listing to reduce payload size
            delete listing.owner;

            return acc;
        }, Promise.resolve(listingData));
    }

    return {
        ...listingData,
        owner,
    };
};
